<div fxLayout="column">
  <app-page-header [section]="'Global Settings'"
                   [title]="'Manage your client profile'"
                   [description]="'The settings page allows you to see general information and enabled properties and offerings. \n'+
'You can create a contact list to improve communication and setup your users’ roles and permissions.'">
  </app-page-header>

  <div fxLayout="column" class="page-content page-padding full-screen-height-page-default">
    <span class="subtitle-default" fxFlexOffset="20px">Client Details</span>

    <div class="full-width" fxLayout="row" fxLayoutGap="20px" fxFlexOffset="30px">
      <div class="info-card" fxLayout="column">
        <span class="heading-default">General information</span>
        <div fxLayout="row" fxLayoutGap="15px" fxFlexOffset="20px">
          <mat-form-field class="custom-text-autofill" appearance="outline">
            <mat-label>Client ID</mat-label>
            <input matInput type="text" [value]="this.loggedInUser?.id!.toString()" disabled>
          </mat-form-field>
          <mat-form-field class="custom-text-autofill" appearance="outline">
            <mat-label>Client Company Name</mat-label>
            <input matInput type="text" [value]="this.currentLandlord?.companyName" disabled/>
          </mat-form-field>
          <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
            <mat-label>Physical Address</mat-label>
            <input matInput type="text" [value]="" disabled/>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="section-divider"><mat-divider></mat-divider></div>

    <span class="subtitle-default" fxFlexOffset="30px">Properties and offerings</span>
    <div class="full-width page-content p-0" fxLayout="row" fxLayoutGap="20px" fxFlexOffset="30px">
      <app-landlord-properties-carousel [properties]="this.properties"
                                        [changeContext]="false"
                                        [showOfferingsOnHover]="true">
      </app-landlord-properties-carousel>
    </div>
  </div>
</div>
